/**
 * @module accountsPayable
 * @description A list of accountsPayable
 */
export const accountsPayable = [
	{
		objectNumber: 52001,
		name: 'Cost of Goods Sold',
	},
	{
		objectNumber: 52008,
		name: 'Insurance Expense',
	},
	{
		objectNumber: 52005,
		name: 'Salaries',
	},
	{
		objectNumber: 52016,
		name: 'Education & Training',
	},
	{
		objectNumber: 52013,
		name: 'Telephone – Land Line',
	},
	{
		objectNumber: 52007,
		name: 'Bank Charges',
	},
	{
		objectNumber: 52017,
		name: 'Repairs & Maintenance',
	},
	{
		objectNumber: 52012,
		name: 'Professional Fees',
	},
	{
		objectNumber: 52011,
		name: 'Accounting Fees',
	},
	{
		objectNumber: 52010,
		name: 'Suppliers Accounts',
	},
	{
		objectNumber: 52004,
		name: 'Rental',
	},
	{
		objectNumber: 52002,
		name: 'Assert Depreciation',
	},
	{
		objectNumber: 52003,
		name: 'Dividends',
	},
	{
		objectNumber: 52006,
		name: 'Utilities',
	},
	{
		objectNumber: 52015,
		name: 'Employee Claims',
	},
	{
		objectNumber: 52009,
		name: 'Advertising Expense',
	},
	{
		objectNumber: 52014,
		name: 'Telephone – Wireless',
	},
]
